import { getBuilder as d } from "@nextcloud/browser-storage";
import { EmojiIndex as g, frequently as u } from "emoji-mart-vue-fast";
import i from "emoji-mart-vue-fast/data/all.json";
/**
 * @copyright Copyright (c) 2021 Jonas Meurer <jonas@freesources.org>
 *
 * @author Jonas Meurer <jonas@freesources.org>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const n = d("nextcloud-vue").persist(!0).build();
var h = /* @__PURE__ */ ((t) => (t[t.Neutral = 1] = "Neutral", t[t.Light = 2] = "Light", t[t.MediumLight = 3] = "MediumLight", t[t.Medium = 4] = "Medium", t[t.MediumDark = 5] = "MediumDark", t[t.Dark = 6] = "Dark", t))(h || {});
const p = (t, r = 10) => {
  const a = new g(i), s = m();
  let e;
  return t ? (e = a.search(":".concat(t), r), e.length < r && (e = e.concat(a.search(t, r - e.length)))) : e = u.get(r).map((c) => a.emoji(c)) || [], e.map((c) => c.getSkin(s));
}, f = function(t) {
  u.add(t);
}, m = () => {
  var t;
  const r = Number.parseInt((t = n.getItem("NcEmojiPicker::currentSkinTone")) != null ? t : "1");
  return Math.min(
    Math.max(
      r,
      1
      /* Neutral */
    ),
    6
    /* Dark */
  );
}, N = (t) => {
  t = Math.min(
    Math.max(
      t,
      1
      /* Neutral */
    ),
    6
    /* Dark */
  ), n.setItem("NcEmojiPicker::currentSkinTone", t.toString());
};
export {
  h as E,
  f as a,
  p as e,
  m as g,
  N as s
};
